// Services/fetchChangeOrderStatus.js
import { ApiRequestInterceptor } from "./apiRequest";
import { ORDERS } from "../Constants/Endpoints";

export const fetchChangeOrderStatus = async (restauranteId, body) => {
  const method = "POST";
  const url = `${ORDERS.changeStatus.replace("{restauranteId}", restauranteId)}`;
  const response = await ApiRequestInterceptor(url, method, body);

  // Normaliza posibles formas: body, data, o ya plano
  const payload =
    (typeof response?.body === "string" ? JSON.parse(response.body) : response?.body) ??
    response?.data ??
    response;

  const statusCode = response?.statusCode ?? payload?.statusCode ?? 200;
  const message = payload?.message ?? response?.message ?? null;
  const order = payload?.order ?? null;

  return { statusCode, message, order, raw: response };
};